"use client";

import { IAirdropTaskRender } from "./task-renderer.types";
import { TaskTypes } from "@/config/task-types";
import { getAirdropArgumentValue } from "@/lib/challenges";
import { QuestTaskButton } from "../quest-task-button";

export const ClickLinkRenderer = ({
  task,
  completeTaskMutation,
  campaign,
  challengesUser,
}: IAirdropTaskRender) => {
  const isShareProgress = task.taskName === TaskTypes.SHARE_PROGRESS;

  // Find the link argument from the campaign task
  const campaignTask = campaign.tasks?.find(
    (campaignTask) => campaignTask.id === task.taskGuid
  );
  const link = campaignTask?.arguments
    ? getAirdropArgumentValue(campaignTask.arguments, "link") || ""
    : "";

  // Function to handle share progress
  const handleShareProgress = (
    points: number,
    campaignName: string,
    referralCode?: string
  ) => {
    // Create the sharing text
    const shareText = `I've earned ${points} points in the ${campaignName} quest! Join me and earn rewards too.${
      referralCode ? ` Use my referral code: ${referralCode}` : ""
    }`;

    // Create Twitter sharing URL
    const twitterUrl = `https://twitter.com/intent/tweet?text=${encodeURIComponent(
      shareText
    )}&url=${encodeURIComponent(window.location.origin)}`;

    // Open the sharing URL in a new tab
    window.open(twitterUrl, "_blank");
  };

  const handleClick = () => {
    if (isShareProgress) {
      const points = Number(challengesUser?.totalPoints ?? 0);
      const referralCode = challengesUser?.referralData?.code;
      const name = campaign.metadata?.name ?? "";

      handleShareProgress(points, name, referralCode);
    } else if (link) {
      window.open(link, "_blank");
    }

    completeTaskMutation.mutateAsync({
      campaignId: campaign.id,
      groupId: campaign.campaignGroup,
      taskName: task.taskName,
      taskGuid: task.taskGuid,
    });
  };

  return (
    <QuestTaskButton
      task={task}
      taskMutation={completeTaskMutation}
      buttonText={isShareProgress ? "Share Progress" : "Claim Reward"}
      onClick={handleClick}
      className="mt-4 "
    />
  );
};

export default ClickLinkRenderer;
